import { render, staticRenderFns } from "./AskForHelp.vue?vue&type=template&id=62d55d24&scoped=true&"
import script from "./AskForHelp.vue?vue&type=script&lang=js&"
export * from "./AskForHelp.vue?vue&type=script&lang=js&"
import style0 from "./AskForHelp.vue?vue&type=style&index=0&id=62d55d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d55d24",
  null
  
)

export default component.exports